//React lib
import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//Third party lib
import { useTranslation } from "react-i18next";
//Internal lib
import OTPInput from "../../component/OTPInput";
import AuthLayout from "../auth-layout";
import "../login/Auth.scss";
import "./Password.scss";
import { AppDispatch } from "../../store/store";
import ActionButton from "../../component/ActionButton";
import Toaster from "../../component/Toaster";
import { verifyOTP } from "../../store/verifyOTPSlice";
import { getOTP } from "../../store/forgetPasswordSlice";
import { CommonUtil, Product } from "../../util/Utils";

const VerifyOtp = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const forgetPassFormValues = useSelector((state: any) => {
    return state.forgetPassword.entity.forgetPassReqParam;
  });
  const navigate = useNavigate();
  const [otpValue, setOTPValue] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(59);
  const [actionProgress, setActionProgress] = useState(false);

  // API call
  const handleSubmit = () => {
    if (otpValue.length === 4) {
      let requestParam: any = Object.assign(
        JSON.parse(JSON.stringify(forgetPassFormValues)),
        { otp: otpValue }
      );
      dispatch(verifyOTP(requestParam))
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            if (result.payload.data.message) {
              Toaster.success(undefined, result.payload.data.message);
            } else {
              Toaster.success(undefined, "OTP verified successfully");
            }
            requestParam["otpToken"] = result?.payload.data.data.otpToken;
            navigate("/reset-password", { state: requestParam });
          } else {
            Toaster.error(undefined, result.payload);
          }
        })
        .catch((err) => {});
    } else {
      Toaster.error(undefined, `${t("resetPassword.enterValidOTP")}`);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const resendOTP = () => {
    setMinutes(0);
    setSeconds(60);
    resendOTPMessage();
  };
  const resendOTPMessage = () => {
    setActionProgress(true);
    const reqData = CommonUtil.copyObject(forgetPassFormValues);
    reqData["productCode"] =
      Product.ProductCode() && Product.ProductCode()?.toUpperCase();
    dispatch(getOTP(reqData))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result.payload.data.message);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch(() => {})
      .finally(() => {
        setActionProgress(false);
      });
  };
  return (
    <Box>
      <Grid
        container
        rowSpacing={1}
        className="center main login-module-background"
      >
        <Grid item xs={10} md={10} lg={8}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            className="viewport-height center"
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              className="login-animation-container theme-bg"
            >
              <AuthLayout />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              className="login-form-container corner-mask otp-verification-form-height"
            >
              <div className="login-padding-get-otp">
                <div className="logo center">
                  <span className="login-module-brand-icon"></span>
                </div>
                <div>
                  <div className="logo-change-password">
                    <span></span>
                    <h6 className="header">
                      {" "}
                      {t("forgetPassword.OTPVerification")}
                    </h6>

                    <div
                      className="default-font-size"
                      style={{ margin: "20px 30px" }}
                    >
                      {`${t("resetPassword.enterOTP")} +91 ${
                        forgetPassFormValues.mobileNo
                      } ${t("and")}
                      ${forgetPassFormValues.email}`}
                    </div>
                    <div className="margin-10">
                      <OTPInput
                        length={4}
                        className="otpContainer margin-down-20 inline-flex"
                        inputClassName="otpInput"
                        isNumberInput
                        autoFocus
                        onChangeOTP={(otp) => setOTPValue(otp)}
                      />
                    </div>

                    <div className="countdown-text margin-down-20">
                      {seconds > 0 || minutes > 0 ? (
                        <p>
                          Time Remaining:{" "}
                          <span style={{ fontWeight: 600 }}>
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </span>
                        </p>
                      ) : (
                        // Display if countdown timer reaches 0
                        <p>{t("otpExpiry.didntReceiveCode")}</p>
                      )}
                    </div>
                    {seconds > 0 || minutes > 0 ? (
                      <div onClick={handleSubmit}>
                        <ActionButton
                          label={t("resetPassword.submitBtnLabel")}
                        />
                      </div>
                    ) : (
                      <div>
                        <ActionButton
                          type="button"
                          onClick={resendOTP}
                          loading={actionProgress}
                          disabled={seconds > 0 || minutes > 0}
                          label={t("otpExpiry.resentOTP")}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default VerifyOtp;
